import accounting from '../accounting.js';
import tippy from 'tippy.js';
//import ApexCharts from 'apexcharts'
$(document).ready(function() {
  $('.js-hero').on('click', function() {
      $('.hero').addClass('fadeOut');
      $('body').removeClass('modal-body-scroll');
      //Hide it all 
      setTimeout(function(){
        $('.hero').hide();
      }, 2000);
    });

    tippy('.tooltip', {})

});




$('#formRoi').submit(function(e) {

  doMath();

  $('input').each(function() {
    var id = $(this).attr('id');
    var value = $(this).val();
    localStorage.setItem('key' + id, value);
    // console.log( id + ' -- ' + value);
  });

  var industry = $("input[name='industry']:checked").val()

  localStorage.setItem('keyIndustry', industry);

  location.href= "./results.html";

  var finalFormOutput = $('#formRoi').serialize();

$.ajax({
type: 'POST',
url: 'https://hello.blackbaud.com/index.php/leadCapture/save',
data: finalFormOutput, // serializes the form's elements.

success: function (data) {
// alert(data); // show response from the php script.
},
complete: function (data) {
//console.log(data + 'complete'); // show response from the php script.
//alert('send me to results');
// window.location = window.location.href + '/results.html?' + formOutput;
//alert('Testing: Check MKTO Post Data then proceed' + location.href + 'results.html?' + formOutput)
//alert('complete: ' + mktoURL)




}
});
e.preventDefault();

});



// $('.js-calculate').on('click', function() {
  // doMath();
  // $('input').each(function() {
    // var id = $(this).attr('id');
    // var value = $(this).val();
    // localStorage.setItem('key' + id, value);
    // // console.log( id + ' -- ' + value);
  // });
  // var industry = $("input[name='industry']:checked").val()
  // localStorage.setItem('keyIndustry', industry);
  // location.href= "./results.html";
// });

/* SO NOT A GREAT IDEA... 
    function getThoseValues(){
  $('.js-hidden-values').each(function(){    
        var id = $(this).attr('id');
        //Getting text isnt good either
        var value = $(this).text();
         localStorage.setItem( 'calc-' + id, value);
        //console.log( id + ' -- ' + value);
    }); 
}
*/
function doMath() {
  var revenue, directMail, majorGiving, online, constituents, mailSent, mailRecipients, annualDonors, majorDonors, emailSent, emailRecipients, mgAvgGift, mgNewDonors, mgConvDonors, mgRevImp, mgRev, mgPercent, dmRevPer, dmAddress, dmRevImp, dmRev, dmPercent, oEmailsSent, oNoEmail, oRevPer, oNewEmail, oRevPerImp, oRevImp, oRev, oPercent, cfIndividuals, cfRevImp, cfRev, totRev, totAddRev, yearOneRevImp, yearTwoRevImp, yearThreeRevImp, totRevYearOne, totRevYearTwo, totRevYearThree, totRevPerDonor;
  var vertical = $("input[name='industry']:checked").val();
  var currentRevenue = parseInt($('.js-revenue').val());
  var directMail = parseInt($('.js-directMail').val());
  var majorGiving = parseInt($('.js-majorGiving').val());
  var online = parseInt($('.js-online').val());
  var constituents = parseInt($('.js-constituents').val());
  var mailSent = parseInt($('.js-mailSent').val());
  var mailRecipients = parseInt($('.js-mailRecipients').val());
  var annualDonors = parseInt($('.js-annualDonors').val());
  var majorDonors = parseInt($('.js-majorDonors').val());
  var emailSent = parseInt($('.js-emailSent').val());
  var emailRecipients = parseInt($('.js-emailRecipients').val());
  var mgAvgGift = majorGiving / majorDonors;
  var mgNewDonors = (annualDonors - majorDonors) * 0.05;
  var mgConvDonors = mgNewDonors * 0.25;
  var mgRevImp = mgAvgGift * mgConvDonors;
  var mgRev = mgRevImp + majorGiving;
  var mgPercent = ((mgRev - majorGiving) / majorGiving) * 100;
  var dmRevPer = directMail / mailSent;
  var dmAddress = mailRecipients * 0.2;
  var dmRevImp = dmAddress * dmRevPer;
  var dmRev = directMail + dmRevImp;
  var dmPercent = ((dmRev - directMail) / directMail) * 100;;
  var oEmailsSent = emailSent / emailRecipients;
  var oNoEmail = constituents - emailRecipients;
  var oRevPer = online / emailSent;
  var oNewEmail = oNoEmail * 0.2;
  var oRevPerImp = oRevPer * 0.6;
  var oRevImp = ((oNewEmail * oEmailsSent) + emailSent) * oRevPerImp;
  var oRev = online + oRevImp;
  var oPercent = ((oRev - online) / online) * 100;;;
  var cfIndividuals = constituents * 0.005;
  var cfRevImp = cfIndividuals * 535;
  var cfRev = cfRevImp;
  var totAddRev = mgRevImp + dmRevImp + oRevImp + cfRevImp;
  var totRev = currentRevenue + totAddRev;
  var yearOneRevImp = totAddRev * .1;
  var yearTwoRevImp = totAddRev * .4;
  var yearThreeRevImp = totAddRev * .5;
  var totRevYearOne = currentRevenue + yearOneRevImp;
  var totRevYearTwo = currentRevenue + yearTwoRevImp;
  var totRevYearThree = currentRevenue + yearThreeRevImp;
  var totRevPerDonor = (currentRevenue + totAddRev) / annualDonors;

  var revCheck = currentRevenue - directMail - majorGiving - online;

  if ( revCheck > 0 ) {
    var miscRevenue = revCheck;
  } else {
    var miscRevenue = 0; 
  }

  
  localStorage.setItem('stored' + 'revenue', accounting.formatMoney(currentRevenue, '$', 0));
  localStorage.setItem('stored' + 'majorGiving', accounting.formatMoney(majorGiving, '$', 0));
  localStorage.setItem('stored' + 'directMail', accounting.formatMoney(directMail, '$', 0));
  localStorage.setItem('stored' + 'online', accounting.formatMoney(online, '$', 0));

  localStorage.setItem('stored' + 'mgAvgGift', accounting.formatMoney(mgAvgGift));
  localStorage.setItem('stored' + 'mgNewDonors', accounting.formatNumber(mgNewDonors));
  localStorage.setItem('stored' + 'mgConvDonors', accounting.formatNumber(mgConvDonors));
  localStorage.setItem('stored' + 'mgRevImp', accounting.formatMoney(mgRevImp));
  localStorage.setItem('stored' + 'mgRev', accounting.formatMoney(mgRev, '$', 0));
  localStorage.setItem('stored' + 'mgPercent', accounting.formatNumber(mgPercent, 2) + '%');
  localStorage.setItem('stored' + 'dmRevPer', accounting.formatMoney(dmRevPer));
  localStorage.setItem('stored' + 'dmAddress', accounting.formatNumber(dmAddress));
  localStorage.setItem('stored' + 'dmRevImp', accounting.formatMoney(dmRevImp));
  localStorage.setItem('stored' + 'dmRev', accounting.formatMoney(dmRev, '$', 0));
  localStorage.setItem('stored' + 'dmPercent', accounting.formatNumber(dmPercent, 2) + '%');
  localStorage.setItem('stored' + 'oEmailsSent', accounting.formatNumber(oEmailsSent));
  localStorage.setItem('stored' + 'oNoEmail', accounting.formatNumber(oNoEmail));
  localStorage.setItem('stored' + 'oRevPer', accounting.formatMoney(oRevPer));
  localStorage.setItem('stored' + 'oNewEmail', accounting.formatNumber(oNewEmail));
  localStorage.setItem('stored' + 'oRevPerImp', accounting.formatMoney(oRevPerImp));
  localStorage.setItem('stored' + 'oRevImp', accounting.formatMoney(oRevImp));
  localStorage.setItem('stored' + 'oRev', accounting.formatMoney(oRev, '$', 0));
  localStorage.setItem('stored' + 'oPercent', accounting.formatNumber(oPercent, 2) + '%');
  localStorage.setItem('stored' + 'cfIndividuals', accounting.formatNumber(cfIndividuals));
  localStorage.setItem('stored' + 'cfRevImp', accounting.formatMoney(cfRevImp));
  localStorage.setItem('stored' + 'cfRev', accounting.formatMoney(cfRev, '$', 0));
  localStorage.setItem('stored' + 'totRev', accounting.formatMoney(totRev, '$', 0));
  localStorage.setItem('unformated' + 'totRev', accounting.formatNumber(totRev, 0, ''));
  localStorage.setItem('stored' + 'totAddRev', accounting.formatMoney(totAddRev, '$', 0));
  localStorage.setItem('stored' + 'yearOneRevImp', accounting.formatMoney(yearOneRevImp));
  localStorage.setItem('stored' + 'yearTwoRevImp', accounting.formatMoney(yearTwoRevImp));
  localStorage.setItem('stored' + 'yearThreeRevImp', accounting.formatMoney(yearThreeRevImp));
  localStorage.setItem('stored' + 'totRevYearOne', accounting.formatMoney(totRevYearOne, '$', 0));
  localStorage.setItem('stored' + 'totRevYearTwo', accounting.formatMoney(totRevYearTwo, '$', 0));
  localStorage.setItem('stored' + 'totRevYearThree', accounting.formatMoney(totRevYearThree, '$', 0));
  localStorage.setItem('unformated' + 'totRevYearOne', accounting.formatNumber(totRevYearOne, 0, ''));
  localStorage.setItem('unformated' + 'totRevYearTwo', accounting.formatNumber(totRevYearTwo, 0, ''));
  localStorage.setItem('unformated' + 'totRevYearThree', accounting.formatNumber(totRevYearThree, 0, ''));
  localStorage.setItem('stored' + 'totRevPerDonor', accounting.formatMoney(totRevPerDonor, '$', 0));
  localStorage.setItem('unformated' + 'totRevPerDonor', accounting.formatNumber(totRevPerDonor, 0, ''));
  localStorage.setItem('stored' + 'totDonors', accounting.formatNumber(annualDonors));
  localStorage.setItem('unformated' + 'totDonors', accounting.formatNumber(annualDonors, 0, ''));
  localStorage.setItem('stored' + 'miscRevenue', accounting.formatMoney(miscRevenue, "$", 0));

  

  
  
  


    //debug only, replacing with local storage

  //$('.mgAvgGift').text(accounting.formatMoney(mgAvgGift));
  //$('.mgNewDonors').text(accounting.formatNumber(mgNewDonors));
  //$('.mgConvDonors').text(accounting.formatNumber(mgConvDonors));
  //$('.mgRevImp').text(accounting.formatMoney(mgRevImp));
  //$('.mgRev').text(accounting.formatMoney(mgRev));
  //$('.mgPercent').text(accounting.formatNumber(mgPercent, 2) + '%');
  //$('.dmRevPer').text(accounting.formatMoney(dmRevPer));
  //$('.dmAddress').text(accounting.formatNumber(dmAddress));
  //$('.dmRevImp').text(accounting.formatMoney(dmRevImp));
  //$('.dmRev').text(accounting.formatMoney(dmRev));
  //$('.dmPercent').text(accounting.formatNumber(dmPercent, 2) + '%');
  //$('.oEmailsSent').text(accounting.formatNumber(oEmailsSent));
  //$('.oNoEmail').text(accounting.formatNumber(oNoEmail));
  //$('.oRevPer').text(accounting.formatMoney(oRevPer));
  //$('.oNewEmail').text(accounting.formatNumber(oNewEmail));
  //$('.oRevPerImp').text(accounting.formatMoney(oRevPerImp));
  //$('.oRevImp').text(accounting.formatMoney(oRevImp));
  //$('.oRev').text(accounting.formatMoney(oRev));
  //$('.oPercent').text(accounting.formatNumber(oPercent, 2) + '%');
  //$('.cfIndividuals').text(accounting.formatNumber(cfIndividuals));
  //$('.cfRevImp').text(accounting.formatMoney(cfRevImp));
  //$('.cfRev').text(accounting.formatMoney(cfRev));
  //$('.totRev').text(accounting.formatMoney(totRev));
  //$('.totAddRev').text(accounting.formatMoney(totAddRev));
  //$('.yearOneRevImp').text(accounting.formatMoney(yearOneRevImp));
  //$('.yearTwoRevImp').text(accounting.formatMoney(yearTwoRevImp));
  //$('.yearThreeRevImp').text(accounting.formatMoney(yearThreeRevImp));
  //$('.totRevYearOne').text(accounting.formatMoney(totRevYearOne));
  //$('.totRevYearTwo').text(accounting.formatMoney(totRevYearTwo));
  //$('.totRevYearThree').text(accounting.formatMoney(totRevYearThree));
  //$('.totRevPerDonor').text(accounting.formatMoney(totRevPerDonor));
  //$('.totDonors').text(accounting.formatNumber(annualDonors));

 // var dataArray = [revenue, directMail, majorGiving, online, constituents, mailSent, mailRecipients, annualDonors, majorDonors, emailSent, emailRecipients, mgAvgGift, mgNewDonors, mgConvDonors, mgRevImp, mgRev, mgPercent, dmRevPer, dmAddress, dmRevImp, dmRev, dmPercent, oEmailsSent, oNoEmail, oRevPer, oNewEmail, oRevPerImp, oRevImp, oRev, oPercent, cfIndividuals, cfRevImp, cfRev, totRev, totAddRev, yearOneRevImp, yearTwoRevImp, yearThreeRevImp, totRevYearOne, totRevYearTwo, totRevYearThree, totRevPerDonor]; 


  var jsonData = {
    "benchmark": [{
        "Vertical": "All",
        "Metric": "Current Donors",
        "Average": "975",
        "Good": "1840",
        "Great": "6090",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "All",
        "Metric": "Current Donors",
        "Average": "412",
        "Good": "626",
        "Great": "1170",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "All",
        "Metric": "Current Donors",
        "Average": "1230",
        "Good": "2040",
        "Great": "4980",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "All",
        "Metric": "Current Donors",
        "Average": "5310",
        "Good": "11890",
        "Great": "39480",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "All",
        "Metric": "Revenue Per Donor",
        "Average": "1730",
        "Good": "2870",
        "Great": "6390",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "All",
        "Metric": "Revenue Per Donor",
        "Average": "981.1",
        "Good": "1490",
        "Great": "2570",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "All",
        "Metric": "Revenue Per Donor",
        "Average": "2170",
        "Good": "3380",
        "Great": "6540",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "All",
        "Metric": "Revenue Per Donor",
        "Average": "3360",
        "Good": "7120",
        "Great": "21800",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "All",
        "Metric": "Total Revenue",
        "Average": "1990000",
        "Good": "3920000",
        "Great": "11180000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "All",
        "Metric": "Total Revenue",
        "Average": "497560",
        "Good": "672600",
        "Great": "886570",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "All",
        "Metric": "Total Revenue",
        "Average": "2700000",
        "Good": "4080000",
        "Great": "6920000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "All",
        "Metric": "Total Revenue",
        "Average": "17690000",
        "Good": "24700000",
        "Great": "46350000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Current Donors",
        "Average": "1430",
        "Good": "3070",
        "Great": "9260",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Current Donors",
        "Average": "596",
        "Good": "790",
        "Great": "2060",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Current Donors",
        "Average": "1690",
        "Good": "3090",
        "Great": "7550",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Current Donors",
        "Average": "3760",
        "Good": "22820",
        "Great": "47280",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Revenue Per Donor",
        "Average": "1620",
        "Good": "2710",
        "Great": "7740",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Revenue Per Donor",
        "Average": "444",
        "Good": "1090",
        "Great": "1650",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Revenue Per Donor",
        "Average": "1860",
        "Good": "2850",
        "Great": "5560",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Revenue Per Donor",
        "Average": "4640",
        "Good": "9880",
        "Great": "20360",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Total Revenue",
        "Average": "2500000",
        "Good": "4720000",
        "Great": "11740000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Total Revenue",
        "Average": "284170",
        "Good": "348570",
        "Great": "713570",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Total Revenue",
        "Average": "2870000",
        "Good": "4250000",
        "Great": "7450000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "animalWelfare",
        "Metric": "Total Revenue",
        "Average": "13780000",
        "Good": "17920000",
        "Great": "36860000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Current Donors",
        "Average": "951",
        "Good": "1710",
        "Great": "7900",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Current Donors",
        "Average": "378",
        "Good": "608",
        "Great": "1080",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Current Donors",
        "Average": "1117",
        "Good": "2450",
        "Great": "9490",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Current Donors",
        "Average": "3300",
        "Good": "7070",
        "Great": "33730",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Revenue Per Donor",
        "Average": "1980",
        "Good": "3290",
        "Great": "8160",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Revenue Per Donor",
        "Average": "976",
        "Good": "1640",
        "Great": "2490",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Revenue Per Donor",
        "Average": "2480",
        "Good": "3960",
        "Great": "7730",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Revenue Per Donor",
        "Average": "6820",
        "Good": "13520",
        "Great": "21810",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Total Revenue",
        "Average": "2280000",
        "Good": "3670000",
        "Great": "9530000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Total Revenue",
        "Average": "535280",
        "Good": "658530",
        "Great": "818920",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Total Revenue",
        "Average": "2880000",
        "Good": "3930000",
        "Great": "7730000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "artsCultureHumanities",
        "Metric": "Total Revenue",
        "Average": "18430000",
        "Good": "23980000",
        "Great": "30560000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "environment",
        "Metric": "Current Donors",
        "Average": "6420",
        "Good": "11510",
        "Great": "21030",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "environment",
        "Metric": "Current Donors",
        "Average": "1610",
        "Good": "1990",
        "Great": "3040",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "environment",
        "Metric": "Current Donors",
        "Average": "6860",
        "Good": "10730",
        "Great": "16600",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "environment",
        "Metric": "Current Donors",
        "Average": "25500",
        "Good": "30480",
        "Great": "46740",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "environment",
        "Metric": "Revenue Per Donor",
        "Average": "504",
        "Good": "662",
        "Great": "1730",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "environment",
        "Metric": "Revenue Per Donor",
        "Average": "374.18",
        "Good": "508.54",
        "Great": "1120",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "environment",
        "Metric": "Revenue Per Donor",
        "Average": "522.13",
        "Good": "717.01",
        "Great": "1740",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "environment",
        "Metric": "Revenue Per Donor",
        "Average": "578.31",
        "Good": "658.55",
        "Great": "1750",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "environment",
        "Metric": "Total Revenue",
        "Average": "3440000",
        "Good": "5670000",
        "Great": "12330000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "environment",
        "Metric": "Total Revenue",
        "Average": "553880",
        "Good": "658390",
        "Great": "872050",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "environment",
        "Metric": "Total Revenue",
        "Average": "3450000",
        "Good": "4730000",
        "Great": "7170000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "environment",
        "Metric": "Total Revenue",
        "Average": "14850000",
        "Good": "17910000",
        "Great": "22200000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "health",
        "Metric": "Current Donors",
        "Average": "1150",
        "Good": "2270",
        "Great": "6410",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "health",
        "Metric": "Current Donors",
        "Average": "451",
        "Good": "708",
        "Great": "1410",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "health",
        "Metric": "Current Donors",
        "Average": "1550",
        "Good": "2600",
        "Great": "5370",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "health",
        "Metric": "Current Donors",
        "Average": "5910",
        "Good": "8640",
        "Great": "17010",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "health",
        "Metric": "Revenue Per Donor",
        "Average": "1480",
        "Good": "2460",
        "Great": "5160",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "health",
        "Metric": "Revenue Per Donor",
        "Average": "822.47",
        "Good": "1310",
        "Great": "2710",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "health",
        "Metric": "Revenue Per Donor",
        "Average": "1790",
        "Good": "2740",
        "Great": "5140",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "health",
        "Metric": "Revenue Per Donor",
        "Average": "3250",
        "Good": "6350",
        "Great": "18730",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "health",
        "Metric": "Total Revenue",
        "Average": "1810000",
        "Good": "4060000",
        "Great": "12930000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "health",
        "Metric": "Total Revenue",
        "Average": "472400",
        "Good": "645360",
        "Great": "862570",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "health",
        "Metric": "Total Revenue",
        "Average": "2680000",
        "Good": "4120000",
        "Great": "6960000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "health",
        "Metric": "Total Revenue",
        "Average": "18530000",
        "Good": "24930000",
        "Great": "41990000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Current Donors",
        "Average": "1050",
        "Good": "1850",
        "Great": "4000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Current Donors",
        "Average": "388",
        "Good": "571",
        "Great": "891",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Current Donors",
        "Average": "1200",
        "Good": "1850",
        "Great": "3270",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Current Donors",
        "Average": "3340",
        "Good": "5500",
        "Great": "12100",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Revenue Per Donor",
        "Average": "2330",
        "Good": "3580",
        "Great": "7410",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Revenue Per Donor",
        "Average": "1200",
        "Good": "1700",
        "Great": "2660",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Revenue Per Donor",
        "Average": "2560",
        "Good": "3620",
        "Great": "6590",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Revenue Per Donor",
        "Average": "5210",
        "Good": "8130",
        "Great": "20030",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Total Revenue",
        "Average": "2850000",
        "Good": "5340000",
        "Great": "14060000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Total Revenue",
        "Average": "523530",
        "Good": "692740",
        "Great": "898360",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Total Revenue",
        "Average": "3170000",
        "Good": "4620000",
        "Great": "7510000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "higherEducation",
        "Metric": "Total Revenue",
        "Average": "17120000",
        "Good": "23430000",
        "Great": "40490000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Current Donors",
        "Average": "975",
        "Good": "1830",
        "Great": "6470",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Current Donors",
        "Average": "434",
        "Good": "640",
        "Great": "1090",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Current Donors",
        "Average": "1260",
        "Good": "2050",
        "Great": "4980",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Current Donors",
        "Average": "9690",
        "Good": "23740",
        "Great": "50430",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Revenue Per Donor",
        "Average": "1540",
        "Good": "2600",
        "Great": "5660",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Revenue Per Donor",
        "Average": "977.37",
        "Good": "1420",
        "Great": "2590",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Revenue Per Donor",
        "Average": "1970",
        "Good": "3150",
        "Great": "6420",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Revenue Per Donor",
        "Average": "1810",
        "Good": "3670",
        "Great": "10980",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Total Revenue",
        "Average": "1890000",
        "Good": "3480000",
        "Great": "9760000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Total Revenue",
        "Average": "548080",
        "Good": "730030",
        "Great": "920260",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Total Revenue",
        "Average": "2500000",
        "Good": "3740000",
        "Great": "6650000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "humanServices",
        "Metric": "Total Revenue",
        "Average": "17680000",
        "Good": "22030000",
        "Great": "38310000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Current Donors",
        "Average": "1490",
        "Good": "3160",
        "Great": "13610",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Current Donors",
        "Average": "394",
        "Good": "637",
        "Great": "1760",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Current Donors",
        "Average": "1610",
        "Good": "2420",
        "Great": "7090",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Current Donors",
        "Average": "10030",
        "Good": "26880",
        "Great": "52370",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Revenue Per Donor",
        "Average": "1560",
        "Good": "2530",
        "Great": "10490",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Revenue Per Donor",
        "Average": "739.25",
        "Good": "1250",
        "Great": "2410",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Revenue Per Donor",
        "Average": "1710",
        "Good": "3010",
        "Great": "8410",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Revenue Per Donor",
        "Average": "2200",
        "Good": "11680",
        "Great": "31030",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Total Revenue",
        "Average": "2660000",
        "Good": "6150000",
        "Great": "25470000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Total Revenue",
        "Average": "456940",
        "Good": "600210",
        "Great": "754550",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Total Revenue",
        "Average": "2740000",
        "Good": "4590000",
        "Great": "6790000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "internationalAffairs",
        "Metric": "Total Revenue",
        "Average": "24460000",
        "Good": "36140000",
        "Great": "73870000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "k12",
        "Metric": "Current Donors",
        "Average": "621",
        "Good": "962",
        "Great": "1710",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "k12",
        "Metric": "Current Donors",
        "Average": "324",
        "Good": "434",
        "Great": "642",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "k12",
        "Metric": "Current Donors",
        "Average": "789",
        "Good": "1120",
        "Great": "1690",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "k12",
        "Metric": "Current Donors",
        "Average": "1920",
        "Good": "2400",
        "Great": "4100",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "k12",
        "Metric": "Revenue Per Donor",
        "Average": "2750",
        "Good": "4200",
        "Great": "7270",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "k12",
        "Metric": "Revenue Per Donor",
        "Average": "1500",
        "Good": "1960",
        "Great": "2910",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "k12",
        "Metric": "Revenue Per Donor",
        "Average": "3510",
        "Good": "4910",
        "Great": "7730",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "k12",
        "Metric": "Revenue Per Donor",
        "Average": "7050",
        "Good": "9610",
        "Great": "27890",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "k12",
        "Metric": "Total Revenue",
        "Average": "1780000",
        "Good": "3320000",
        "Great": "7350000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "k12",
        "Metric": "Total Revenue",
        "Average": "526240",
        "Good": "701030",
        "Great": "900640",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "k12",
        "Metric": "Total Revenue",
        "Average": "2690000",
        "Good": "3980000",
        "Great": "6490000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "k12",
        "Metric": "Total Revenue",
        "Average": "13880000",
        "Good": "18430000",
        "Great": "30510000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Current Donors",
        "Average": "3960",
        "Good": "5520",
        "Great": "30540",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Current Donors",
        "Average": "0",
        "Good": "0",
        "Great": "0",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Current Donors",
        "Average": "2640",
        "Good": "3790",
        "Great": "4050",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Current Donors",
        "Average": "30540",
        "Good": "40020",
        "Great": "49490",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "1910",
        "Good": "2030",
        "Great": "2500",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "0",
        "Good": "0",
        "Great": "0",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "1910",
        "Good": "1990",
        "Great": "2050",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "2030",
        "Good": "2380",
        "Great": "2740",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Total Revenue",
        "Average": "6980000",
        "Good": "13700000",
        "Great": "40980000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Total Revenue",
        "Average": "0",
        "Good": "0",
        "Great": "0",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Total Revenue",
        "Average": "4880000",
        "Good": "6650000",
        "Great": "7150000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "mutualMembershipBenefit",
        "Metric": "Total Revenue",
        "Average": "40980000",
        "Good": "49370000",
        "Great": "57760000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Current Donors",
        "Average": "985",
        "Good": "1870",
        "Great": "5840",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Current Donors",
        "Average": "493",
        "Good": "803",
        "Great": "1560",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Current Donors",
        "Average": "1010",
        "Good": "1710",
        "Great": "4160",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Current Donors",
        "Average": "3830",
        "Good": "7990",
        "Great": "47410",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "2240",
        "Good": "4670",
        "Great": "15880",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "674.55",
        "Good": "1140",
        "Great": "2490",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "2640",
        "Good": "5400",
        "Great": "13160",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Revenue Per Donor",
        "Average": "6310",
        "Good": "19570",
        "Great": "62450",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Total Revenue",
        "Average": "2760000",
        "Good": "5920000",
        "Great": "17710000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Total Revenue",
        "Average": "487340",
        "Good": "655400",
        "Great": "879100",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Total Revenue",
        "Average": "3010000",
        "Good": "4650000",
        "Great": "7860000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "publicSocietalBenefit",
        "Metric": "Total Revenue",
        "Average": "20600000",
        "Good": "33350000",
        "Great": "75420000",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "religion",
        "Metric": "Current Donors",
        "Average": "1380",
        "Good": "2960",
        "Great": "19570",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "religion",
        "Metric": "Current Donors",
        "Average": "541",
        "Good": "786",
        "Great": "2120",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "religion",
        "Metric": "Current Donors",
        "Average": "1550",
        "Good": "2800",
        "Great": "8720",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "religion",
        "Metric": "Current Donors",
        "Average": "17270",
        "Good": "26000",
        "Great": "36770",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "religion",
        "Metric": "Revenue Per Donor",
        "Average": "1230",
        "Good": "2170",
        "Great": "5820",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "religion",
        "Metric": "Revenue Per Donor",
        "Average": "646.94",
        "Good": "1240",
        "Great": "2320",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "religion",
        "Metric": "Revenue Per Donor",
        "Average": "1460",
        "Good": "2390",
        "Great": "5590",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "religion",
        "Metric": "Revenue Per Donor",
        "Average": "1350",
        "Good": "4580",
        "Great": "11690",
        "FundraisingRevenue": "Large"
      },
      {
        "Vertical": "religion",
        "Metric": "Total Revenue",
        "Average": "2160000",
        "Good": "5110000",
        "Great": "16840000",
        "FundraisingRevenue": "All"
      },
      {
        "Vertical": "religion",
        "Metric": "Total Revenue",
        "Average": "472540",
        "Good": "658920",
        "Great": "830660",
        "FundraisingRevenue": "Small"
      },
      {
        "Vertical": "religion",
        "Metric": "Total Revenue",
        "Average": "2450000",
        "Good": "4420000",
        "Great": "6550000",
        "FundraisingRevenue": "Medium"
      },
      {
        "Vertical": "religion",
        "Metric": "Total Revenue",
        "Average": "18060000",
        "Good": "24360000",
        "Great": "54050000",
        "FundraisingRevenue": "Large"
      }
    ]
  };
  if (currentRevenue < 1000000) {
    var fundraisingSize = "Small";
  } else if (currentRevenue >= 1000000 && currentRevenue < 10000000) {
    var fundraisingSize = "Medium";
  } else if (currentRevenue >= 10000000) {
    var fundraisingSize = "Large";
  }
  if (vertical == 'animalWelfare') { var printVertical = 'Animal Welfare nonprofits'; } else if (vertical == 'artsCultureHumanities') { var printVertical = 'Arts, Culture, and Humanities nonprofits'; } else if (vertical == 'environment') { var printVertical = 'Environment nonprofits'; } else if (vertical == 'health') { var printVertical = 'Healthcare institutions'; } else if (vertical == 'higherEducation') { var printVertical = 'Higher Education nonprofits'; } else if (vertical == 'humanServices') { var printVertical = 'Human Services nonprofits'; } else if (vertical == 'internationalAffairs') { var printVertical = 'International Affairs nonprofits'; } else if (vertical == 'k12') { var printVertical = 'K-12 nonprofits'; } else if (vertical == 'mutualMembershipBenefit') { var printVertical = 'Mutual and Membership Benefit nonprofits'; } else if (vertical == 'publicSocietalBenefit') { var printVertical = 'Public and Societal Benefit nonprofits'; } else if (vertical == 'religion') { var printVertical = 'Religion nonprofits'; } else if (vertical == 'other') { var printVertical = 'Social Good nonprofits'; }

  //$('.printVertical').text(printVertical);
  localStorage.setItem('stored' + 'printVertical', printVertical);
  //console.log('printVertical = ' + printVertical);
  //console.log('vertical = ' + vertical);
  //console.log('Size = ' + fundraisingSize);

  //var mapVarsToStorage = {
    //revenue: "revenue",
    //directMail: "directMail",
    //majorGiving: "majorGiving",
    //online: "online",
    //constituents: "constituents",
    //mailSent: "mailSent",
    //mailRecipients: "mailRecipients",
    //annualDonors: "annualDonors",
    //majorDonors: "majorDonors",
    //emailSent: "emailSent",
    //emailRecipients: "emailRecipients",
    //mgAvgGift: "mgAvgGift",
    //mgNewDonors: "mgNewDonors",
    //mgConvDonors: "mgConvDonors",
    //mgRevImp: "mgRevImp",
    //mgRev: "mgRev",
    //mgPercent: "mgPercent",
    //dmRevPer: "dmRevPer",
    //dmAddress: "dmAddress",
    //dmRevImp: "dmRevImp",
    //dmRev: "dmRev",
    //dmPercent: "dmPercent",
    //oEmailsSent: "oEmailsSent",
    //oNoEmail: "oNoEmail",
    //oRevPer: "oRevPer",
    //oNewEmail: "oNewEmail",
    //oRevPerImp: "oRevPerImp",
    //oRevImp: "oRevImp",
    //oRev: "oRev",
    //oPercent: "oPercent",
    //cfIndividuals: "cfIndividuals",
    //cfRevImp: "cfRevImp",
    //cfRev: "cfRev",
    //totRev: "totRev",
    //totAddRev: "totAddRev",
    //yearOneRevImp: "yearOneRevImp",
    //yearTwoRevImp: "yearTwoRevImp",
    //yearThreeRevImp: "yearThreeRevImp",
    //totRevYearOne: "totRevYearOne",
    //totRevYearTwo: "totRevYearTwo",
    //totRevYearThree: "totRevYearThree",
    //totRevPerDonor: "totRevPerDonor",
    //fundraisingSize: "fundraisingSize",
    //printVertical: "printVertical"
//
  //};
  //$.each(mapVarsToStorage, function(key, id) {
    ////var thisval = eval(key);
    ////var formatBasic = accounting.formatMoney(thisval);
    ////console.table(thisval , key)
    ////localStorage.setItem( 'calculatedValues-' + key, thisval);
  //});

  $.each(jsonData.benchmark, function(i, v) {
    if (
      v.Vertical == vertical &
      v.Metric == "Total Revenue" &
      v.FundraisingRevenue == fundraisingSize) {
      console.log(v.Metric)
      console.log('avg = ' + v.Average);
      console.log('good = ' + v.Good);
      console.log('great = ' + v.Great);
      //$('.benchFundraisingAvg').text(accounting.formatMoney(v.Average));
      //$('.benchFundraisingGood').text(accounting.formatMoney(v.Good));
      //$('.benchFundraisingGreat').text(accounting.formatMoney(v.Great));

      localStorage.setItem('stored' + "benchFundraisingAvg", v.Average);
      localStorage.setItem('stored' + "benchFundraisingGood", v.Good);
      localStorage.setItem('stored' + "benchFundraisingGreat", v.Great);
    }
    if (
      v.Vertical == vertical &
      v.Metric == "Revenue Per Donor" &
      v.FundraisingRevenue == fundraisingSize) {
      console.log(v.Metric)
      console.log('avg = ' + v.Average);
      console.log('good = ' + v.Good);
      console.log('great = ' + v.Great);
      //$('.benchRevPerDonorAvg').text(accounting.formatMoney(v.Average));
      //$('.benchRevPerDonorGood').text(accounting.formatMoney(v.Good));
      //$('.benchRevPerDonorGreat').text(accounting.formatMoney(v.Great));

      localStorage.setItem('stored' + "benchRevPerDonorAvg", v.Average);
      localStorage.setItem('stored' + "benchRevPerDonorGood", v.Good);
      localStorage.setItem('stored' + "benchRevPerDonorGreat", v.Great);

    }
    if (
      v.Vertical == vertical &
      v.Metric == "Current Donors" &
      v.FundraisingRevenue == fundraisingSize) {
      console.log(v.Metric)
      console.log('avg = ' + v.Average);
      console.log('good = ' + v.Good);
      console.log('great = ' + v.Great);
      var benchRevPerDonorAvg = v.Average
      //$('.benchDonorsAvg').text(accounting.formatNumber(v.Average));
      //$('.benchDonorsGood').text(accounting.formatNumber(v.Good));
      //$('.benchDonorsGreat').text(accounting.formatNumber(v.Great));

      localStorage.setItem('stored' + "benchDonorsAvg", v.Average);
      localStorage.setItem('stored' + "benchDonorsGood", v.Good);
      localStorage.setItem('stored' + "benchDonorsGreat", v.Great);

    }
  });
} //DOMATH FUNCTION


$(document).ready(function() {});

var storedprintVertical = localStorage.getItem('storedprintVertical');
var storedrevenue = localStorage.getItem('storedrevenue');
var storedmajorGiving = localStorage.getItem('storedmajorGiving');
var storedonline = localStorage.getItem('storedonline');
var storeddirectMail = localStorage.getItem('storeddirectMail');
var storedmgRev = localStorage.getItem('storedmgRev');
var storeddmRev = localStorage.getItem('storeddmRev');
var storedoRev = localStorage.getItem('storedoRev');
var storedcfRev = localStorage.getItem('storedcfRev');
var storedtotRev = localStorage.getItem('storedtotRev');
var unformatedtotRev = localStorage.getItem('unformatedtotRev');
var storedtotAddRev = localStorage.getItem('storedtotAddRev');
var storedtotRevYearOne = localStorage.getItem('storedtotRevYearOne');
var storedtotRevYearTwo = localStorage.getItem('storedtotRevYearTwo');
var storedtotRevYearThree = localStorage.getItem('storedtotRevYearThree');
var unformatedtotRevYearOne = localStorage.getItem('unformatedtotRevYearOne');
var unformatedtotRevYearTwo = localStorage.getItem('unformatedtotRevYearTwo');
var unformatedtotRevYearThree = localStorage.getItem('unformatedtotRevYearThree');
var storedbenchFundraisingAvg = localStorage.getItem('storedbenchFundraisingAvg');
var storedbenchFundraisingGood = localStorage.getItem('storedbenchFundraisingGood');
var storedbenchFundraisingGreat = localStorage.getItem('storedbenchFundraisingGreat');
var storedbenchRevPerDonorAvg = localStorage.getItem('storedbenchRevPerDonorAvg');
var storedbenchRevPerDonorGood = localStorage.getItem('storedbenchRevPerDonorGood');
var storedbenchRevPerDonorGreat = localStorage.getItem('storedbenchRevPerDonorGreat');
var storedbenchDonorsAvg = localStorage.getItem('storedbenchDonorsAvg');
var storedbenchDonorsGood = localStorage.getItem('storedbenchDonorsGood');
var storedbenchDonorsGreat = localStorage.getItem('storedbenchDonorsGreat');
var storedtotRevPerDonor = localStorage.getItem('storedtotRevPerDonor');
var unformatedtotRevPerDonor = localStorage.getItem('unformatedtotRevPerDonor');
var storedtotDonors = localStorage.getItem('storedtotDonors');
var unformatedtotDonors = localStorage.getItem('unformatedtotDonors');
var storedmiscRevenue = localStorage.getItem('storedmiscRevenue');
var storedKeyIndustry = localStorage.getItem('keyIndustry');


//mapping industry values to Marketo Values
if (storedKeyIndustry == 'animalWelfare') { var organizationtypemkto = 'Animal Welfare'; } else if (storedKeyIndustry == 'artsCultureHumanities') { var organizationtypemkto = 'Arts, Culture, and Humanities'; } else if (storedKeyIndustry == 'environment') { var organizationtypemkto = 'Environment'; } else if (storedKeyIndustry == 'health') { var organizationtypemkto = 'Health'; } else if (storedKeyIndustry == 'higherEducation') { var organizationtypemkto = 'Higher Education'; } else if (storedKeyIndustry == 'humanServices') { var organizationtypemkto = 'Human Services'; } else if (storedKeyIndustry == 'internationalAffairs') { var organizationtypemkto = 'International Affairs'; } else if (storedKeyIndustry == 'k12') { var organizationtypemkto = 'K-12'; } else if (storedKeyIndustry == 'mutualMembershipBenefit') { var organizationtypemkto = 'Mutual and Membership Benefit'; } else if (storedKeyIndustry == 'publicSocietalBenefit') { var organizationtypemkto = 'Public and Societal Benefit'; } else if (storedKeyIndustry == 'religion') { var organizationtypemkto = 'Religion'; } else if (storedKeyIndustry == 'other') { var organizationtypemkto = 'Other'; }

console.log('organizationtypemkto ' + organizationtypemkto);
$('#organizationtypemkto').val(organizationtypemkto);


//min max on annotation values

if ( unformatedtotRev > storedbenchFundraisingGreat ) {
  var unformatedtotRevMinMax = storedbenchFundraisingGreat; //capping annotation value to keep it on canvas
} else { 
  var unformatedtotRevMinMax = unformatedtotRev;
 }


if ( unformatedtotRevPerDonor > storedbenchRevPerDonorGreat ) {
  var unformatedtotRevPerDonorMinMax = storedbenchRevPerDonorGreat; //capping annotation value to keep it on canvas
} else {
  var unformatedtotRevPerDonorMinMax = unformatedtotRevPerDonor;
}

if ( unformatedtotDonors > storedbenchDonorsGreat ) {
  var unformatedtotDonorsMinMax = storedbenchDonorsGreat; //capping annotation value to keep it on canvas
} else {
  var unformatedtotDonorsMinMax = unformatedtotDonors;
}


$('.printVertical').text(storedprintVertical);
$('.currentRevenue').text(storedrevenue);

$('.currentMajorGiving').text(storedmajorGiving);
$('.currentOnline').text(storedonline);
$('.currentDirectMail').text(storeddirectMail);

$('.mgRev').text(storedmgRev);
$('.dmRev').text(storeddmRev);
$('.oRev').text(storedoRev);
$('.cfRev').text(storedcfRev);
$('.miscRevenue').text(storedmiscRevenue);

if ( storedmiscRevenue == '$0') {
  $('.dblock-miscRevenue').hide();
}



$('.totRev').text(storedtotRev);
$('.totAddRev').text(storedtotAddRev);
$('.totRevYearOne').text(storedtotRevYearOne);
$('.totRevYearTwo').text(storedtotRevYearTwo);
$('.totRevYearthree').text(storedtotRevYearThree);

var annotationValue = 1204519;
var bigPicture = [unformatedtotRevYearOne, unformatedtotRevYearTwo, unformatedtotRevYearThree];

var fundraisingBenchmarks = [storedbenchFundraisingAvg, storedbenchFundraisingGood, storedbenchFundraisingGreat];
var revPerDonorBenchmarks = [storedbenchRevPerDonorAvg, storedbenchRevPerDonorGood, storedbenchRevPerDonorGreat];
var donorBenchmarks = [storedbenchDonorsAvg, storedbenchDonorsGood, storedbenchDonorsGreat];





//CHART ROI PROJECTION #chartProjectedRoi
var options = {
  series: [{
    name: 'Revenue',
    type: 'area',
    data: bigPicture
  }],
  chart: {
    toolbar: {
      show: false
    },
     zoom: {
          enabled: false,
    },
    height: 350,
    type: 'area',
    colors: ["rgba(124, 198, 78, 1.000)"]
  },
   stroke: {
          curve: 'straight',
          width: 5,
          colors: ['#b7dfa3', '#98dcc4', '#80d8f5'],
          lineCap: 'round'
        },

       fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            gradientToColors: [ '#84daee'],
            shadeIntensity: 1,
            type: 'vertical',
            opacityFrom: 1,
            opacityTo: 0.5,
            stops: [0, 100, 100, 100]
          },
        },
  //circles on line
  markers: {
    size: 5,
    colors: ["#fff"],
    strokeColor: "#7cc64e",
    strokeWidth: 3
  },
  //DATA numbers on the line 
  dataLabels: {
    enabled: false,
    formatter: function(val) {
      return accounting.formatMoney(val, '$', 0);
    },
    offsetY: -20,
    offsetX: 2,
    style: {
      fontSize: '12px',
      colors: ["rgba(124, 198, 78, 1.000)"],
      padding: 10
    }
  },
  xaxis: {
    categories: ["", "", ""],
    position: 'bottom',
    show: false,
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: true
    },
    tooltip: {
      enabled: false,
    }
  },
  yaxis: {
    axisBorder: {
      show: false
    },
    tooltip: {
      enabled: false,
    },
    axisTicks: {
      show: true,
    },
    labels: {
      show: false,
      formatter: function(val) {
        //return val + "yax";
      }
    }
  },
  annotations: {
    yaxis: [{
      y: annotationValue,
      borderColor: '#394a52',
      borderWidth: 4,
      lineCap: 'round',
      strokeDashArray: 4,
      tooltip: {
      enabled: false,
    },
      label: {
        borderColor: '#00E396',
        style: {
          color: '#fff',
          background: '#ccc'
        },
        text: 'Current Revenue'
      }
    }]
  },
  title: {
    text: '',
    floating: false,
    offsetY: 0,
    align: 'center',
    style: {
      color: '#444'
    }
  }
};


if ($("#chartProjectedRoi")[0]) { 
  var chart = new ApexCharts(document.querySelector("#chartProjectedRoi"), options);
chart.render();
}








/* ==================================================
    BENCHMARK GLOBAL SETTINGS
================================================== */
Apex.chart = {
  toolbar: {
    show: false
  },
  height: 350,
  type: 'bar',
}
Apex.plotOptions = {
  bar: {
    borderRadius: 10,
    dataLabels: {
      position: 'top', // top, center, bottom
    },
  }
}
Apex.dataLabels = {
  enabled: true,
  formatter: function(val) {
    return accounting.formatNumber(val) ;
  },
  offsetY: -10,
  style: {
    fontSize: '14px',
    colors: ["rgba(57, 74, 82, 0.700)"]
  }
}
Apex.fill = {
  type: "gradient",
  gradient: {
    shadeIntensity: 1,
    //colors: ['#71bf44', 'red', 'green'],
    opacityFrom: 1,
    type: "vertical",
    opacityTo: 1,
    stops: [0, 50, 100],
    colorStops: [{
      offset: 0,
      color: "#e0e9e9",
      opacity: 0.8
    }]
  }
}
Apex.xaxis = {
  categories: ["Good", "Better", "Best"],
  position: 'bottom',
  labels: {
    style: {
      colors: [''],
      fontSize: '18px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 800,
      cssClass: 'apexcharts-xaxis-label',
    }
  },
  axisBorder: {
    show: false
  },
  axisTicks: {
    show: false
  },
  crosshairs: {
    fill: {
      type: 'solid',
      gradient: {
        colorFrom: '#D8E3F0',
        colorTo: '#BED1E6',
        stops: [0, 100],
        opacityFrom: 0.4,
        opacityTo: 0.5,
      }
    }
  },
  tooltip: {
    enabled: true,
  }
}
Apex.yaxis = {
  axisBorder: {
    show: false
  },
  axisTicks: {
    show: false,
  },
  labels: {
    show: false,
    formatter: function(val) {
      //return val + "%";
    }
  }
}
//DOESNT SEEM TO BE WORKING FOR ANNOTATIONS GLOBALLY
Apex.annotations = {
  yaxis: [{
    y: 100000,
    borderColor: '#394a52',
    borderWidth: 4,
    lineCap: 'round',
    strokeDashArray: 4,
    label: {
      borderColor: '#00E396',
      style: {
        color: '#fff',
        background: '#ccc'
      },
      text: 'Current Revenue'
    }
  }]
}
/* ==================================================
    
================================================== */


//Options Block Update Variables 
//replace with Current Calculation
var setAnnotationValue = unformatedtotRevMinMax;
var setAnnotationText = 'Projected: ' + storedtotRev ;
var setBarColor =  'rgba(25, 114, 186, 0.7)';
//replace with JSON DATA VALUES
var setDataSeries = fundraisingBenchmarks;
var options = {
  series: [{
    name: 'Revenue',
    type: 'column',
    data: setDataSeries
  }],
  chart: {
  //height: 350,
  type: 'bar',
  },
  dataLabels: {
  formatter: function(val) {
    return "$" + accounting.formatNumber(val)
  },
},
  fill: {
    gradient: {
        colorStops: [{
        color: setBarColor
        }]
    }
  },
  annotations: {
  yaxis: [{
    y: setAnnotationValue,
    borderColor: '#394a52',
    borderWidth: 1,
    lineCap: 'round',
    strokeDashArray: 7,
    label: {
      style: {
        color: '#fff',
        background: '#394a52'
      },
      text: setAnnotationText
    }
  }]
}
};


if ($("#chartFundraising")[0]) {
  var chart = new ApexCharts(document.querySelector("#chartFundraising"), options);
chart.render();
}



//Options Block Update Variables 
//replace with Current Calculation
var setAnnotationValue = unformatedtotDonorsMinMax;
var setAnnotationText = 'Projected: ' + storedtotDonors ;
var setBarColor =  'rgba(0, 183, 149, 0.7)';
//replace with JSON DATA VALUES
var setDataSeries = donorBenchmarks
var options = {
  series: [{
    name: 'Revenue',
    type: 'column',
    data: setDataSeries
  }],
  chart: {
  //height: 350,
  type: 'bar',
  },
    
  fill: {
    gradient: {
        colorStops: [{
        color: setBarColor
        }]
    }
  },
  annotations: {
  yaxis: [{
    y: setAnnotationValue,
    borderColor: '#394a52',
    borderWidth: 1,
    lineCap: 'round',
    strokeDashArray: 7,
    label: {
      style: {
        color: '#fff',
        background: '#394a52'
      },
      text: setAnnotationText
    }
  }]
}
};


if ($("#chartDonors")[0]) { 
  var chart = new ApexCharts(document.querySelector("#chartDonors"), options);
chart.render();
}




//Options Block Update Variables 
//replace with Current Calculation
var setAnnotationValue = unformatedtotRevPerDonorMinMax;
var setAnnotationText = 'Projected: ' + storedtotRevPerDonor ;
var setBarColor =  [ 'rgba(40, 175, 229, 0.700)'];
//replace with JSON DATA VALUES
var setDataSeries = revPerDonorBenchmarks
var options = {
  series: [{
    name: 'Revenue',
    type: 'column',
    data: setDataSeries
  }],
  chart: {
  //height: 350,
  type: 'bar',
  },
  dataLabels: {
  formatter: function(val) {
    return "$" + accounting.formatNumber(val)
  },
},
  fill: {
    gradient: {
        colorStops: [{
        color: setBarColor
        }]
    }
  },
  annotations: {
  yaxis: [{
    y: setAnnotationValue,
    borderColor: '#4d5360',
    borderWidth: 1,
    lineCap: 'round',
    strokeDashArray: 7,
    label: {
      style: {
        color: '#fff',
        background: '#4d5360'
      },
      text: setAnnotationText
    }
  }]
}
};


if ($("#chartRevPer")[0]) { 
  var chart = new ApexCharts(document.querySelector("#chartRevPer"), options);
chart.render();
}




//SCAN THROUGH ALL LOCALSTORAGE AND MAKE IT A GLOBAL VARIABLE
for (let [key, value] of Object.entries(localStorage)) {
    window.eval("var " + key + " = " + "'" + value + "';");
    console.log(`${key}: ${value}`);
}

//EXAMPLE OF OUTPUT
setTimeout(function(){
  console.log(keymajorGiving); 
}, 100);
  


//prototype
console.log('home.js loaded');
